export const requireImage = (link) => {
  return require(`@/assets/${link}`)
}
export default requireImage
